import React from 'react'

import { NavLink } from 'react-router-dom'
import logo from '../images/LOGO-transparent.png'

const Common = ({ name, visit, imgsrc, btname, content, side }) => {
    return (
        <>
            <section id="header" className="d-flex align-items-center">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-10 mx-auto">
                            <div className="row">
                                <div className="col-md-6 pt-5 pt-lg-0 order-2 order-lg-1 d-flex 
                            animate__animated animate__fadeInLeft justify-content-center flex-column">
                                    <div className="my-2 ">
                                        <h1>{name}<br />
                                            <strong style={{ fontFamily: 'Dancing Script', fontSize: "3.4rem" }} className="">CareerGrads</strong><img src={logo} alt='careergrads'
                                                style={{ width: '80px', height: '80px', cursor: 'pointer' }} />

                                        </h1>
                                    </div>

                                    <h3 className="my-3 diff">
                                        {content}
                                    </h3>
                                    <div className="mt-3 mb-4">
                                        <NavLink to={visit == 0 ? '' : `${visit}`} className={btname == 0 ? "d-none" : "btn-get-started font-weight-bold"}>{btname == 0 ? "" : btname}</NavLink></div>

                                </div>
                                <div className={`col-lg-6 order-1 img-fluid img-responsive text-center ${side}`}>
                                    <img src={imgsrc} alt="header-img" className="img-fluid animated " />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Common
